// extracted by mini-css-extract-plugin
export default {"halfButtonContainer":"Homepage_halfButtonContainer__gbjQi","button":"Homepage_button__vHcxb","yourNumber":"Homepage_yourNumber__rdYg4","bigNumber":"Homepage_bigNumber__L6NPW"};